import { useUnit } from 'effector-react'
import { useNavigate } from 'react-router'

import ChevronRightIcon from '@/assets/icons/icon-chevron-right.svg'
import { $creatorId } from '@/models/creators.ts'

export interface Breadcrumb {
  name: string
  to?: string
}

export interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[]
}

export const Breadcrumbs = ({ breadcrumbs }: BreadcrumbsProps) => {
  const creatorId = useUnit($creatorId)
  const navigate = useNavigate()

  const handleLinkClick = (to?: string) => () => {
    if (to && creatorId) {
      navigate(to.replace(':creatorId', creatorId.toString()))
    }
  }

  return (
    <div className="flex">
      {breadcrumbs.map((breadcrumb: Breadcrumb) => {
        return breadcrumb.to ? (
          <div
            key={breadcrumb.name}
            className="flex gap-2 items-center "
          >
            <div
              className="text-sm text-primary-500 font-medium underline cursor-pointer leading-5"
              onClick={handleLinkClick(breadcrumb.to)}
            >
              {breadcrumb.name}
            </div>
            <ChevronRightIcon className="text-secondary-300" />
          </div>
        ) : (
          <div
            key={breadcrumb.name}
            className="text-sm text-text-sub font-medium leading-5"
          >
            {breadcrumb.name}
          </div>
        )
      })}
    </div>
  )
}
